import { render } from "./TheHeader.vue?vue&type=template&id=132673ec&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=132673ec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-132673ec"

export default script